var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.path !== '/chargingPage')?_c('van-nav-bar',{attrs:{"title":_vm.pageTitle,"left-arrow":_vm.$route.meta.index > 2,"fixed":""},on:{"click-left":_vm.onClickLeft}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }